import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';
import { retryEndpointsList } from '../models';
import { ignoreInterceptorHeaders } from '@rx-applications/shared/utils';

export const genericRetryStrategy = () => (errorResponse: Observable<HttpErrorResponse>) =>
  errorResponse.pipe(
    mergeMap((error, i) => {
      const retryAttempt = i + 1;

      const retryParams = retryEndpointsList.find(
        (r) => error.url && error.url.toLowerCase().includes(r.endpoint.toLowerCase())
      );

      if (!retryParams || retryAttempt > retryParams.attempts || !retryParams.shouldRetry(error)) {
        return throwError(error);
      }

      return timer(retryParams.delay);
    })
  );

@Injectable({ providedIn: 'root' })
export class RetryInterceptor implements HttpInterceptor {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(ignoreInterceptorHeaders.ignoreRetry)) {
      const requestClone = request.clone({
        headers: request.headers.delete(ignoreInterceptorHeaders.ignoreRetry),
      });
      return next.handle(requestClone);
    }

    return next.handle(request).pipe(retryWhen(genericRetryStrategy()));
  }
}
